import { render } from "./Building.vue?vue&type=template&id=480a952c&scoped=true"
import script from "./Building.vue?vue&type=script&lang=js"
export * from "./Building.vue?vue&type=script&lang=js"

import "./Building.vue?vue&type=style&index=0&id=480a952c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-480a952c"

export default script